import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"

import useCoachingGroups from "./useCoachingGroups"
import useCurrentClient from "./useCurrentClient"

const useSetInitialClient = () => {
  const { currentCoachingGroup } = useCurrentClient()
  const navigate = useNavigate()
  const { sortedCoachingGroups } = useCoachingGroups()
  const location = useLocation()

  useEffect(() => {
    if (currentCoachingGroup) return
    if (!sortedCoachingGroups || sortedCoachingGroups.length === 0) return

    navigate(`/${sortedCoachingGroups[0].id}/messages`)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortedCoachingGroups, location.pathname])
}

export default useSetInitialClient
